// WooCommerce continues to own variation matching, reset behaviour and submission.
(function($) {
    const initialized = new WeakMap();

    function initialize(form) {
        const wrapper = form.querySelector('.tfa-format-selector');
        if (!wrapper || initialized.has(wrapper) || typeof $.fn.wc_variation_form !== 'function') {
            return;
        }
        const select = wrapper.querySelector('select[name="attribute_pa_format"]');
        const fieldset = wrapper.querySelector('.tfa-format-options');
        const radios = [...wrapper.querySelectorAll('input[type="radio"]')];
        if (!select || !fieldset || !radios.length) {
            return;
        }

        const availability = new Map(radios.map(radio => [radio.dataset.variationId, radio.dataset.available === 'true']));
        const liveAvailability = new Map();
        const permitted = variation => variation.variation_is_active !== false &&
            variation.variation_is_visible !== false && variation.is_purchasable !== false && variation.is_in_stock !== false;

        function sync() {
            const variations = $(form).data('product_variations');
            if (Array.isArray(variations)) {
                variations.forEach(variation => availability.set(String(variation.variation_id), permitted(variation)));
            }
            radios.forEach(radio => {
                const option = [...select.options].find(option => option.value === radio.value);
                radio.disabled = select.disabled || !option || option.disabled || !(liveAvailability.get(radio.dataset.variationId) ?? availability.get(radio.dataset.variationId));
                radio.checked = select.value === radio.value;
            });

            // If an extension selects an option we could not render reliably, reveal the native control.
            const supported = !select.value || radios.some(radio => radio.value === select.value);
            wrapper.querySelector('.tfa-format-native').hidden = supported;
            fieldset.hidden = !supported;
            const label = select.closest('tr')?.querySelector('th.label');
            if (label) {
                label.classList.toggle('tfa-format-native-label', supported);
            }
            wrapper.classList.toggle('tfa-format-initialized', supported);
        }

        $(wrapper).on('change.tfaFormat', 'input[type="radio"]', function() {
            // Recheck the original option in case WooCommerce has just removed or disabled it.
            sync();
            if (!this.disabled) {
                select.value = this.value;
                $(select).trigger('change');
            }
            sync();
        });
        $(select).on('change.tfaFormat', sync);
        $(form).on('woocommerce_update_variation_values.tfaFormat reset_data.tfaFormat', sync);
        $(form).on('reload_product_variations.tfaFormat', function() {
            liveAvailability.clear();
            sync();
        });
        $(form).on('found_variation.tfaFormat', function(event, variation) {
            if (variation) {
                liveAvailability.set(String(variation.variation_id), permitted(variation));
            }
            sync();
        });
        // Some integrations replace option nodes without emitting WooCommerce events.
        const observer = new MutationObserver(sync);
        observer.observe(select, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'selected'] });
        initialized.set(wrapper, observer);
        sync();
    }

    $(document).on('wc_variation_form.tfaFormat', 'form.variations_form', function() {
        initialize(this);
    });
    $(function() {
        document.querySelectorAll('form.variations_form').forEach(initialize);
    });
})(jQuery);
